import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { NotFoundComponent } from '../components/not-found/not-found.component';
import {ContactsListComponent} from "./contacts-list.component";

const routes: Routes = [
  {
    path: 'contacts',
    component: SideNavComponent,
    children: [
      {
        path: 'people',
        component: ContactsListComponent,
        data: { tab: 'people', icon: 'person', },
        pathMatch: 'full',
      },
      {
        path:"organizations",
        component: ContactsListComponent,
        data: {tab:'organizations', icon:'apartment'},
        pathMatch:'full',
      },
      {
        path: "sponsors",
        component: ContactsListComponent,
        data: {tab: 'sponsors', icon: 'account_balance'},
        pathMatch:'full'
      },
      {
        path: '',
        component: NotFoundComponent,
        pathMatch: 'full',
      },
      {
        path: '**',
        component: NotFoundComponent,
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContactsRoutingModule {}
